import React from 'react';
import { View, Text, StyleSheet, Pressable } from 'react-native';
import CardIcon from './CardIcon';
import FlipIcon from '../../../../components/Icons/FlipIcon';
import { Credential } from '../../../../types/credentials';
import { FontScale, getFluidSpacing } from '../../../../helpers/utils';

interface CardHeaderProps {
  credential: Credential;
  onFlip?: () => void;
}

/**
 * @description Card header component
 * @param {CardHeaderProps} { credential, onFlip }
 * @return {React.FC}
 */
const CardHeader: React.FC<CardHeaderProps> = ({ credential, onFlip }) => {
  return (
    <View style={styles.headerContainer}>
      <View style={styles.credentialCardIcon}>
        <CardIcon credential={credential} />
      </View>
      <View style={styles.credentialCardTextContainer}>
        <Text
          style={[
            styles.credentialCardNameText,
            { color: '#fff', fontSize: FontScale.cardCaption() }
          ]}>
          {credential.name}
        </Text>
        <Text
          style={[
            styles.credentialCardIssuerText,
            { color: '#fff', fontSize: FontScale.cardCaption() }
          ]}>
          {credential.issuer}
        </Text>
      </View>
      <Pressable onPress={onFlip} style={styles.flipIconContainer}>
        <FlipIcon iconWidth={20} iconHeight={20} />
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: getFluidSpacing(16, 18, 20),
    zIndex: 1
  },
  credentialCardIcon: {
    width: 48,
    height: 48,
    borderRadius: 4,
    overflow: 'hidden'
  },
  credentialCardIssuerText: {
    fontWeight: 400
  },
  credentialCardNameText: {
    fontWeight: 400
  },
  credentialCardTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    flex: 1
  },
  flipIconContainer: {
    padding: 8,
    marginLeft: 'auto'
  },
  flipIcon: {
    width: 20,
    height: 20
  }
});

export default CardHeader;
